import { DEAL_REFRESH_APP_NAME_WHITELIST, COMMON_CONSUMER_APP_NAME } from '@makemydeal/dr-sales-checkin-types';

/**
 * Effective deal-refresh app-name whitelist, evaluated per socket event.
 *
 * CMD/AMD are always included (gated upstream by the GTL edition capability). Common Consumer is
 * added only when the `enableCommonConsumerPersonaFallback` feature toggle is on for the dealer,
 * mirroring the per-dealer rollout used in Manager View. So CC refresh requires BOTH the GTL
 * capability (checked by the caller) AND this toggle, while CMD/AMD are unaffected.
 *
 * The toggle is read directly off `state.featureToggles` (the same lightweight pattern used by
 * `correlationMiddleware`) so this stays usable inside middleware without the shared selector's
 * pre-bootstrap precondition throw.
 */
export const getDealRefreshAppNameWhitelist = (state: any): string[] => {
    const isCommonConsumerEnabled =
        (state.featureToggles as Record<string, boolean | undefined>)?.enableCommonConsumerPersonaFallback ?? false;

    return isCommonConsumerEnabled
        ? [...DEAL_REFRESH_APP_NAME_WHITELIST, COMMON_CONSUMER_APP_NAME]
        : [...DEAL_REFRESH_APP_NAME_WHITELIST];
};
